export default "__VITE_ASSET__tktbqb44__"